module.exports = __webpack_public_path__ + "1792395595471/images/40px.1f07573.png";